import React, { memo } from 'react'

import * as styles from './tabs.module.scss'
import TabButton from './tabButton/tabButton'
import { TabsProps } from './types'

const Tabs = ({ tabItems, activeTabId, onTabClick }: TabsProps) => (
   <ul className={styles.tabs}>
      {tabItems.map((tabItem) => (
         <li key={tabItem.label} className={tabItem.isHidden ? styles.hidden : ''}>
            <TabButton
               {...tabItem}
               isActive={tabItem.id === activeTabId}
               onTabClick={onTabClick}
            />
         </li>
      ))}
   </ul>
)

export default memo(Tabs)
